import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  width: 1040px;
  height: 100%;
  padding-bottom: 60px;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
`;

export const EmptySpace = styled.div<{ height: string }>`
  height: ${({ height }) => height || "40px"};
  background-color: transparent;
`;

export const Title = styled.h1`
  font-size: 32px;
  line-height: 40px;
  text-align: center;
  color: white;
  font-weight: 600;

  @media screen and (max-width: 768px) {
    font-size: 24px;
    line-height: 34px;
    text-align: left;
    padding-left: 20px;
  }
`;
